import { render, staticRenderFns } from "./CarrierList.vue?vue&type=template&id=605b0bf3&"
import script from "./CarrierList.vue?vue&type=script&lang=js&"
export * from "./CarrierList.vue?vue&type=script&lang=js&"
import style0 from "./CarrierList.vue?vue&type=style&index=0&id=605b0bf3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports